import Vue from 'vue';

(function ( scope ){
    'use strict';

    var Defects = function (){
        this.initComponents();
        this.addEventHandlers();
        this.onResize(null);
    };

    Defects.prototype.initComponents = function (){
    };

    Defects.prototype.addEventHandlers = function (){

        this.filter = new Vue({
            el: '#defects',
            data: {},
            methods : {
                isMobile : isMobile,
                scrollTop : function (){
                    $('html, body').animate({
                        scrollTop: $(".deffect_list").offset().top
                    }, 600, function() {
                    });
                }
            }
        });

        document.onscroll = function() {scrollFunction()};

        function scrollFunction() {
            var offsetTop = document.querySelector('.section_defects_table').offsetTop
            var scrollbtn = document.querySelector('#scrolltop')
            scrollbtn.style.display = (document.body.scrollTop > offsetTop || document.documentElement.scrollTop > offsetTop ? "block" : "none");
        }

        $('.deffect-gallery').each(function (){
            $(this).magnificPopup({
                delegate: '.popup',
                type: 'image',
                fixedContentPos: false,
                fixedBgPos: false,
                autoFocusLast: true,
                gallery: {
                    enabled: true,
                    navigateByImgClick: true
                },
                image: {
                    markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' +
                        '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '</div>' + '</div>',
                    titleSrc: function ( item ){
                        return $(item.el[ 0 ]).data('description');
                    },
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
                }
            });
        });

        $('.scroll').click(function(e) {
            e.preventDefault();
            var height = document.querySelector(".js-table-defects thead").offsetHeight-1;
            var mobile_menu_height = document.querySelector(".navigation.mobile").offsetHeight+1;
            var width = $( window ).width();
            var target = $(this).attr('href');
            var minus = (width <= 900 ? mobile_menu_height : height)

            $('html, body').animate({
                scrollTop: ($(target).offset().top - minus)
            }, 1000);
        });

        this.resizeHandler = this.onResize.bind(this);
        window.APP.app.resizeHooks.push(this.resizeHandler);
    };

    Defects.prototype.onResize = function ( width ){};

    scope.Defects = Defects;
})(window.APP || (window.APP = {}));
